import { render, staticRenderFns } from "./BusInspectionWorkshopGroupModal.vue?vue&type=template&id=5b91ac37&"
import script from "./BusInspectionWorkshopGroupModal.vue?vue&type=script&lang=js&"
export * from "./BusInspectionWorkshopGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports